import React from 'react';
import loadImage from 'blueimp-load-image';

class LogoInput extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
        };
    }

    async handleChange(e) {
        this.props.onStart();

        // get the files
        let files = this.props.multiple ? [...e.target.files] : [e.target.files[0]];

        for (const file of files) {
            await loadImage.parseMetaData(file, async (data) => {
                //default image orientation
                var orientation = 0;
                //if exif data available, update orientation
                if (data.exif) {
                    orientation = data.exif.get('Orientation');
                }
                var loadingImage = await loadImage(
                    file,
                    async (canvas) => {
                        var base64data = canvas.toDataURL('image/png');
                        this.props.onDone(base64data);
                    },
                    {
                        //should be set to canvas : true to activate auto fix orientation
                        canvas: true,
                        orientation: orientation,
                    },
                );
                console.log(data, loadingImage);
            });
        } // for
    }


    render() {
        return (
            <input
                type="file"
                accept=".gif,.jpg,.jpeg,.png"
                onChange={this.handleChange.bind(this)}
                multiple={false}
            />
        );
    }
}

LogoInput.defaultProps = {
    multiple: false,
};

export default LogoInput;



// WEBPACK FOOTER //
// ./src/components/inputs/Logo.js